import styled, { css } from 'styled-components';

export const Label = styled('span')`
  ${({ theme }) => theme.typography.xSmall}
`;

interface DateProps {
  error?: string;
}

const datefield = css<DateProps>`
  display: inline-block;
  input {
    ${({ error, theme }) =>
      error && `border-bottom: 1px solid ${theme.color.badRGBA(0.9)}`};
  }
`;

export const DateSmall = styled('div')<DateProps>`
  width: 50px;
  margin-right: ${({ theme }) => theme.x1spacePx}px;
  ${datefield}
`;

export const DateLarge = styled('div')<DateProps>`
  width: 60px;
  ${datefield}
`;
